import UserDetailsView from "../view/view";
import {connect} from "react-redux";
import {UserDetailsActions} from "../actions/table_actions";
import { RootState } from "../../../app/store";
import { Dispatch } from '@reduxjs/toolkit';
import {requestDataFromAPI, requestModuleCatalogFromAPI, requestModulesUpdateFromAPI, requestTierUpdateFromAPI, requestUserUpdateFromAPI, requestUserCLientListFromAPI, requestUserNotCLientListFromAPI, requestClientToogle, requestEnrollmentCode, requestToleranceUpdateFromAPI, requestTargetsUpdateFromAPI} from "../thunk/table_tunc";
import {requestToleranceDefaultFromAPI} from "../../LicenseCreateInput/thunk/request_func";
import {deactivateUserFromAPI, deleteUserFromAPI} from "../../UserTableThingy/thunk/table_tunc";
import {requestRemoveLicence, requestRestoreLicence} from "../../LicenseTableThingy/thunk/table_tunc";
import {ADMIN_ROLE} from "../../UpdateInputThingy/typing/emergencyUpload";
import {LocalProps} from '../view/view';

interface OwnProps {
    id:string;
    uuid:string;
}

const mapStateToProps = (state:RootState, ownProps:OwnProps & {match:any}) => {  
    const myprops=
    {
        licensedetails:state.LicenseDetails.model.license,
       // usermandanten:state.UserDetails.model.mandantenlist,
        //listmandanten:state.UserDetails.model.listmandanten,
        loadeduuid:ownProps.match.params.uuid,
        loaded:state.LicenseDetails.view.loaded,
        toleranceDefault:state.LicenseDetails.model.toleranceDefault,
        moduleCatalog:state.LicenseDetails.model.moduleCatalog,
        selectedTier:state.LicenseDetails.model.selectedTier,
        isAdmin:state.LoginManager.model.role === ADMIN_ROLE,
        key: 'tab1',
        importantMapType:state.LicenseDetails,
    }
    return myprops;
}

  function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps & {match:any}){
      return {
        onLoadRequested:(uuid:string)=>{ 
            dispatch(requestDataFromAPI(uuid) as any);
            dispatch(requestToleranceDefaultFromAPI((percent) => dispatch(UserDetailsActions.SetToleranceDefault({percent}))) as any);
            dispatch(requestModuleCatalogFromAPI() as any);
        },
        saveTargetTolerance:(uuid:string, percent:number | null) => {
            (requestToleranceUpdateFromAPI(uuid, percent) as any)(dispatch)
        },
        saveModules:(uuid:string, names:string[]) => {
            dispatch(requestModulesUpdateFromAPI(uuid, names) as any);
        },
        saveTier:(uuid:string, tier:string) => {
            dispatch(requestTierUpdateFromAPI(uuid, tier) as any);
        },
        removeLicence:(uuid:string, inUseText:string) => {
            dispatch(requestRemoveLicence(uuid, inUseText, () => dispatch(requestDataFromAPI(uuid) as any)) as any);
        },
        restoreLicence:(uuid:string) => {
            dispatch(requestRestoreLicence(uuid, () => dispatch(requestDataFromAPI(uuid) as any)) as any);
        },
        saveTargets:(uuid:string, count:number) => {
            dispatch(requestTargetsUpdateFromAPI(uuid, count) as any);
        },
        deactivateUser:(uuid:string)=>{ 
            dispatch(deactivateUserFromAPI(uuid) as any);
        },
        deleteUser:(uuid:string)=>{ 
            dispatch(deleteUserFromAPI(uuid) as any);
        },
        onConfigChange:(data:any, type:string)=>{
            console.log(data,type);
            const action = UserDetailsActions.SetUserDetail({data:data, type});
            console.log(action);
            dispatch(action);
            console.log("Parameter SET -> DONE");
        },
        CopyUserToNew:(data:any) => {
            dispatch(UserDetailsActions.CopyUserToNew({data:data}))
        },
        requestUserUpdateFromAPI:(data:any, uuid:any) => {
            (requestUserUpdateFromAPI(data, uuid)  as any)(dispatch)
        },
        requestUserCLientListFromAPI:(uuid:any) => {
            (requestUserCLientListFromAPI(uuid)  as any)(dispatch)
        },
        requestUserNotCLientListFromAPI:(uuid:any) => {
            (requestUserNotCLientListFromAPI(uuid)  as any)(dispatch)
        },
        issueEnrollmentCode:(uuid:string) => {
            (requestEnrollmentCode(uuid) as any)(dispatch)
        },
        requestClientToogle:(uuid:string, useruuid:string, action:string) => {
            (requestClientToogle(uuid, useruuid, action)  as any)(dispatch)
        },
        
      }
  }

  const mergeProps = (
      mapProps:ReturnType<typeof mapStateToProps>, 
      dispatchProps:ReturnType<typeof bindDispatchToActions>,
      ownProps:OwnProps & {match:any}
      ) => {
    
    const mergedProps:LocalProps = 
    {
        licensedetails:mapProps.licensedetails,
        //usermandanten:mapProps.usermandanten,
        //listmandanten:mapProps.listmandanten,
        loadeduuid:mapProps.loadeduuid,
        loaded:mapProps.loaded,
        toleranceDefault:mapProps.toleranceDefault,
        moduleCatalog:mapProps.moduleCatalog,
        selectedTier:mapProps.selectedTier,
        isAdmin:mapProps.isAdmin,
        key: 'tab1',
        saveTargetTolerance:dispatchProps.saveTargetTolerance,
        saveTargets:dispatchProps.saveTargets,
        saveTier:dispatchProps.saveTier,
        saveModules:dispatchProps.saveModules,

        onLoadRequested:dispatchProps.onLoadRequested,
        requestUserCLientListFromAPI: dispatchProps.requestUserCLientListFromAPI,
        requestUserNotCLientListFromAPI: dispatchProps.requestUserNotCLientListFromAPI,
        requestClientToogle:dispatchProps.requestClientToogle,
        issueEnrollmentCode:dispatchProps.issueEnrollmentCode,
        removeLicence:dispatchProps.removeLicence,
        restoreLicence:dispatchProps.restoreLicence,
        deactivateUser:dispatchProps.deactivateUser,
        deleteUser:dispatchProps.deleteUser,
        onConfigChange:dispatchProps.onConfigChange,

        onSubmit:(data:any, uuid:any)=>{       
          dispatchProps.requestUserUpdateFromAPI(data, uuid); //Data is wrong I need to be merge witrh maprops.changeduserdetails
          console.log("Dispatch should be done");
          // setTimeout(() => {
          //       console.log("Update User Table now");
          //       dispatch(requestDataFromAPI(uuid) as any);
          //   }, 2000);
          
      }
    }
    return mergedProps;
  }

const UserDetailContainer=connect(mapStateToProps, bindDispatchToActions, mergeProps)(UserDetailsView);
export default UserDetailContainer;